// Espelho de domain.Vinculo.ValorSugerido (backend): o valor que um plantão do vínculo
// recebe quando o médico não digita outro. Sábado e domingo usam o valor de fim de semana
// (se o vínculo tiver um); vale o dia em que o plantão começa e feriado não conta.
// O backend é a fonte de verdade: um lote sem valor é precificado por ele, data a data.

// "yyyy-MM-dd" -> true no sábado e no domingo. Lê o dia em UTC para não depender do fuso
// do navegador (new Date("2026-11-07") é meia-noite UTC).
export function isWeekendDate(isoDate) {
  if (!isoDate) return false;
  const dia = new Date(`${isoDate}T00:00:00Z`).getUTCDay();
  return dia === 0 || dia === 6;
}

export function hasWeekendRate(vinculo) {
  return vinculo?.valor_fim_de_semana != null;
}

export function suggestedShiftValue(vinculo, isoDate) {
  if (!vinculo) return "";
  if (hasWeekendRate(vinculo) && isWeekendDate(isoDate)) return vinculo.valor_fim_de_semana;
  return vinculo.valor_plantao;
}

// Um lote mistura preços quando o vínculo cobra diferente no fim de semana e as datas
// caem dos dois lados.
export function datesHaveMixedRates(vinculo, isoDates) {
  if (!hasWeekendRate(vinculo)) return false;
  const weekend = isoDates.map(isWeekendDate);
  return weekend.some(Boolean) && weekend.some((w) => !w);
}
